import { StudentCertificate } from '@/interfaces/studentCertificate';
import { queryStudentCertificate } from '@/services/studentCertificate.service';
import { Effect, Reducer } from '@umijs/max';
import { redirectNotFound } from '@/utils/errorRedirect';

export interface ModelType {
  namespace: string;
  state: { certificate: null | StudentCertificate };
  effects: {
    sendHistory: Effect;
    fetchCertificateDetail: Effect;
  };
  reducers: {
    setCertificate: Reducer<any>;
    setHistory: Reducer<any>;
  };
}

const Model: ModelType = {
  namespace: 'studentCertificateDetails',

  state: {
    certificate: null,
  },

  effects: {
    *fetchCertificateDetail({ payload }, { call, put, all }) {
      try {
        const [ response ] = yield all([call(queryStudentCertificate, payload)]);
  
        yield put({
          type: 'setCertificate',
          payload: { certificate: response.data },
        });
      } catch (error) {
        redirectNotFound(error);
      }
    },

    *sendHistory({ payload }) {
      yield {
        type: 'setHistory',
        payload,
      };
    },
  },

  reducers: {
    setCertificate(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    setHistory(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
